"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _interval = _interopRequireDefault(require("@use-it/interval")); // @use-it/interval is definitely in
// packages/ui/package.json. Looks like its probably
// monorepo related:
// https://github.com/benmosher/eslint-plugin-import/issues/1174
// eslint-disable-next-line import/no-extraneous-dependencies


function makeTickWhichChild(children, doLoop) {
  return function tickWhichChild(whichChild) {
    if (whichChild < children.length - 1) {
      return whichChild + 1;
    } else if (doLoop) {
      return 0;
    } else {
      return whichChild;
    }
  };
}

var TimedDisplay = function TimedDisplay(_ref) {
  var children = _ref.children,
      timing = _ref.timing,
      doLoop = _ref.doLoop;
  var timingFn = typeof timing === 'function' ? timing : function () {
    return timing;
  };

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      whichChild = _useState2[0],
      setWhichChild = _useState2[1];

  var delay = timingFn(whichChild + 1);
  var tickWhichChild = makeTickWhichChild(children, doLoop);
  (0, _interval.default)(function () {
    setWhichChild(tickWhichChild);
  }, delay);
  return children[whichChild];
};

TimedDisplay.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.oneOf([null])])).isRequired,
  timing: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]).isRequired,
  doLoop: _propTypes.default.bool
};
var _default = TimedDisplay;
exports.default = _default;